import { render, staticRenderFns } from "./AssignEquipmentHistory.vue?vue&type=template&id=86a4b6da&scoped=true"
import script from "./AssignEquipmentHistory.vue?vue&type=script&lang=js"
export * from "./AssignEquipmentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a4b6da",
  null
  
)

export default component.exports